export default {
    exnum: 'Exnum：',
    exhibitor: 'Exhibitor：',
    area: 'Booth Area：',
    name: 'Name',
    mandanary: 'madatory pay',
    unit_price: 'unit Price',
    num: 'Number/Period',
    canForegift: 'Is Foregift',
    canInvoice: 'Is Invoice',
    sumary: 'Subtotal',
    remark: 'Remark',
    start_time: 'Start Time',
    end_time: 'End Time',
    choose_fee: 'Total fees selected',
    go_pay: 'Go to pay',
    go_rent: 'Go to rent',
    foregift_remark: 'Instructions on application for deposit refund',
    foregift_notice_1: 'To apply for refund of deposit, please click on the home page',
    foregift_notice_2: '"Foregift"',
    foregift_notice_3: 'button, and fill in the information',
    sure_btn: 'Sure',
    invoice_remark: 'Application for invoice description',
    invoice_notice_1: 'To apply for the invoice, please click on the home page',
    invoice_notice_2: '"Invoice"',
    invoice_notice_3: 'button, and fill in the information',
    price_notice: 'Description of valuation method',
    count_way: 'Valuation methods',
    start_time_less_error: 'The starting time of the fee you choose must not be less than',
    start_time_between_error: 'The starting time of the fee you choose should not be less than the ending time',
    start_time_more_error: 'The starting time of your choice must not be greater than',
    end_time_less_error: 'The end time of your choice must be no less than',
    end_time_between_error: 'The end time of your choice must not be greater than',
    end_time_more_error: 'The end time you choose should be no less than the start time',
    back_to_booth: 'Back to choose booth',
    no_message: 'There is no fixed fee information unless you have choose booth',
    fee_total:'Fee Total:',
	'勾选展位中需要缴纳的费用(需要现场现金刷卡或使用预授权支付的不需要在这里勾选，可以在现场完成支付)':'Check out the fees that need to be paid in the booth (cash or pre-authorized payment is not required here, these payment can be completed offline)',
	'该项费用不可重复缴纳':'This fee is not duplicated.',
	'请先选择时间后再勾选该项费用':'Please choose the time before checking the fee.',
  '下单说明':'Place an order Explain',
  '采用单一价格计算':'Calculating at a single price',
  '单价':'Unit Price:',
  '总价':'Total price:',
  '采用最小单位计价':'Applying Minimum Unit Pricing',
  '单位计算总价':'Unit Price *（Duration/Unit value）= Total price',
  '单价时长总价':'（Unit Price * Duration = Total price）',
  '加班时长':'Overtime hours：',
  '小时':'hour',
  '费用计算的最小时长':'time unit of cost calculation：',
  '最小面积':'（hour），Minimum area：',
  '最小单位计算':'（Square meter），The deficiency is calculated in the smallest unit。',
  '采用面积范围计价':'Applying Area Range Valuation',
  '采用阶梯计价':'Applying ladder pricing',
  '未选择费用项':'No fees selected, no fees paid',
  '报馆费用缴纳':'Fixed fee payment',
  '费用列表':'Cost List',
  '已选展位':'Selected booth',
  '共':'a total of ',
  '个':'booths',
  "选择数量":"Quantity",
  "可选时间范围":"Range time",
  "选择时间":"Selection time",
  "计价说明":"Valuation notes",
  "请选择需要缴纳的费用项，当前展位已选中费用合计":"Please select the fees to be paid. The total fee for the selected booth is ",

  "已选择":"",
  "个展位，费用合计":" booths have been selected, at a total cost of ",
  "返回上一步":"Previous step",
  "去结算":"Settlement",

  "您选择的时间不在可选范围内":"The time you selected is not in the optional range."




  }


// WEBPACK FOOTER //
// ./src/i18n/en-us/fixedFee.js